export enum MapComponent {
    GOOGLE = "GOOGLE",
    MAPBOX = "MAPBOX"
}

export interface GeoCoordinates{
    lat: number,
    lng: number
}

export enum GoogleMapsStatus {
    PENDING = "PENDING",
    LOADED = "LOADED",
    ERROR = "ERROR"
}
